import React, { useEffect } from 'react';

import style from './ContactUsPage.module.css';

const ContactUsPage = React.memo(() => {
  useEffect(() => {
    document.title = 'HUB Portal: Inquiries and Support';
  }, []);

  return (
    <div className={style.contactUs}>
      <h1>Inquiries and Support</h1>
      <div className={style.email}>
        <span className={style.title}>Email:</span>
        <p className={style.info}>
          <a href="mailto:SPG_smarthubservice@specialtyprogramgroup.com">
            SPG_smarthubservice@specialtyprogramgroup.com
          </a>
        </p>
      </div>
      <div className={style.phone}>
        <span className={style.title}>Call:</span>
        <p className={style.info}>(888) 960-3926</p>
      </div>
      <div className={style.hours}>
        <span className={style.title}>Hours of Operation:</span>
        <p className={style.info}>8 am - 5:30 pm CT Monday - Friday</p>
      </div>
    </div>
  );
});

export default ContactUsPage;
